var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./instructionsToCreateCourseFromLms.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4a507c35!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./instructionsToCreateCourseFromLms.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/courses/components/instructionsToCreateCourseFromLms.vue
// module id = 2405
// module chunks = 61